/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { adminModelPagedResultSchema } from "../adminModelPagedResultSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiAdminsQueryParamsSchema = z.object({
    "SortByLogin": z.boolean().describe("Сортировка по логину").optional(),
"SortByLoginDesc": z.boolean().describe("Сортировка по логину (с конца)").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список администраторов
 */
export const getApiAdmins200Schema = z.lazy(() => adminModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiAdmins400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiAdmins401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiAdmins403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiAdmins500Schema = z.lazy(() => badResponseModelSchema)

export const getApiAdminsQueryResponseSchema = z.lazy(() => getApiAdmins200Schema)